// src/components/Auth/LoginButton.jsx
import React from 'react';
import { LogIn, LogOut } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

const LoginButton = () => {
  const { user, signIn, signOut } = useAuth();

  const handleAuth = async () => {
    try {
      if (user) {
        await signOut();
      } else {
        await signIn();
      }
    } catch (error) {
      console.error('Authentication error:', error);
    }
  };

  return (
    <button
      onClick={handleAuth}
      className="w-full flex items-center justify-between px-4 py-3 text-white hover:bg-white/10 transition-colors"
    >
      <span className="text-sm font-medium">{user ? 'Sign Out' : 'Sign In'}</span>
      <span className="flex items-center justify-center h-8 w-8 rounded-full bg-white/10">
        {user ? <LogOut className="h-4 w-4 text-white" /> : <LogIn className="h-4 w-4 text-white" />}
      </span>
    </button>
  );
};

export default LoginButton;